import axios from 'axios';
import store from '@/store/index';

// TODO: change this all over to offbase functionality that makes sense

const Offbase = {
     async getClaims() {
          return await axios({
               method: 'GET',
          });
     },
     async saveClaimData(claimData) {
          return await axios({
               method: 'POST',
               url: process.env.VUE_APP_API_URI2 + '/offbase',
               data: claimData,
          });
     },
     async getPresignedUrls(fileLog) {
          return await axios({
               method: 'POST',
               url: process.env.VUE_APP_API_URI2 + '/claims/upload',
               data: {
                    files: fileLog,
               },
          });
     },
     async uploadFiles(signedUrl, file, config) {
          return await axios({
               method: 'PUT',
               url: signedUrl,
               headers: {
                    'Content-Type': 'binary/octet-stream',
               },
               processData: true,
               data: file,
               ...config,
          });
     },
     getClaimStatus(claim) {
          if (claim.status !== 'CLOSED') {
               if (claim.real_claim_id) {
                    return 'Open';
               }

               if (!claim.real_claim_id) {
                    return 'Pending';
               }
          } else {
               return 'Closed';
          }
     },
};

export default Offbase;
